<template>
    <v-row v-if="!$store.getters.progress" class="ma-0">
		<v-col class="pa-0">
            <show
                :id="id"
                :model-def="modelDef"
                :model-class="modelClass"
                :activities="true"
                :maillogs="false"
                :fileuploader="false">
                <template slot="relations">
                    <v-row class="ma-0">
                        <v-col cols="12" class="pa-0 pb-4">
                            <crud
                                title='Aziende associate'
                                action-icon='business'
                                model-def='companies'
                                :sub-filters="subFilters"
                                :default-input="{agent_id: id}"
                                action-position='absolute'
                                :redirect="redirect"
                                :position-left="true"
                                :position-right="false"
                                direction="right"
                            ></crud>
                        </v-col>
                    </v-row>
                </template>
            </show>
        </v-col>
    </v-row>
</template>

<script>
    import RevenueChart from '@/components/common/RevenueChart'
    import CompaniesDistribution from '@/components/common/CompaniesDistribution'

    export default {
        name: 'agent',
        components: {
            RevenueChart,
            CompaniesDistribution,
        },
        props: {
            id: Number,
        },
        
        data() {
            return {
                modelDef: 'agents',
                modelClass: 'agent',
                subFilters: {agents: this.id},
                redirect: {modelDef: 'agents', id: this.id},
            }
        },

        created() {
           this.$store.commit('endProgress')
        },
    }
</script>